import { __assign } from '../../../../../../node_modules/tslib/tslib.es6.js';
import React__default, { useImperativeHandle } from 'react';
import { Box, Popper, Grow, ClickAwayListener } from '@mui/material';
import { MenuContent } from './atoms.js';

var getPlacementStyles = function (placement, matchAnchorWidth) {
    switch (placement) {
        case "bottom-start":
            return {
                transformOrigin: "left top",
                borderRadius: "0 ".concat(matchAnchorWidth ? 0 : 10, "px 4px 4px"),
            };
        case "bottom-end":
            return {
                transformOrigin: "right top",
                borderRadius: "".concat(matchAnchorWidth ? 0 : 10, "px 0 4px 4px"),
            };
        default:
            return {
                transformOrigin: "auto",
                borderRadius: "4px",
            };
    }
};
var ZigMenu = function (_a, innerRef) {
    var _b;
    var _c = _a.id, id = _c === void 0 ? "" : _c, component = _a.component, options = _a.options, _d = _a.placement, placement = _d === void 0 ? "bottom-end" : _d, _e = _a.matchAnchorWidth, matchAnchorWidth = _e === void 0 ? false : _e, sx = _a.sx, menuSx = _a.menuSx, disabled = _a.disabled;
    var _f = React__default.useState(false), open = _f[0], setOpen = _f[1];
    var anchorRef = React__default.useRef(null);
    var _g = React__default.useState(null), expandedOption = _g[0], setExpandedOption = _g[1];
    var handleToggle = function () {
        setOpen(function (prevOpen) { return !prevOpen; });
        if (expandedOption)
            setExpandedOption(null);
    };
    var handleClose = function (event) {
        var _a;
        if ((event === null || event === void 0 ? void 0 : event.target) && ((_a = anchorRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
            return;
        }
        setOpen(false);
        setExpandedOption(null);
    };
    var placementStyles = getPlacementStyles(placement, matchAnchorWidth);
    var prevOpen = React__default.useRef(open);
    React__default.useEffect(function () {
        if (prevOpen.current && !open) {
            anchorRef.current.focus();
        }
        prevOpen.current = open;
    }, [open]);
    useImperativeHandle(innerRef, function () { return ({
        closeDropDown: function () {
            handleClose();
        },
        open: open,
    }); }, [anchorRef.current, open]);
    var onClick = function (cb) { return function (e) {
        handleClose(e);
        cb === null || cb === void 0 ? void 0 : cb();
    }; };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Box, { "aria-controls": open ? "composition-menu" : undefined, "aria-expanded": open ? "true" : undefined, "aria-haspopup": "true", ref: anchorRef, role: "button", onClick: !disabled ? handleToggle : undefined, id: id && "".concat(id, "-container"), sx: __assign({ cursor: "pointer" }, sx) }, component({ open: open })),
        options && open && (React__default.createElement(Popper, { open: open, anchorEl: anchorRef.current, role: "presentation", placement: placement, transition: true, disablePortal: false, sx: __assign({ minWidth: matchAnchorWidth ? (_b = anchorRef.current) === null || _b === void 0 ? void 0 : _b.offsetWidth : "245px", zIndex: 1300, "> div": {
                    boxShadow: "0 4px 6px -2px #00000061",
                    borderRadius: placementStyles.borderRadius,
                    overflow: "hidden",
                    backgroundColor: "neutral800",
                }, "*": {
                    whiteSpace: "normal",
                }, transform: "scale(0)" }, menuSx), modifiers: [
                {
                    name: "preventOverflow",
                    enabled: true,
                    options: {
                        altAxis: true,
                        altBoundary: true,
                        tether: false,
                    },
                },
            ] }, function (_a) {
            var TransitionProps = _a.TransitionProps;
            return (React__default.createElement(Grow, __assign({}, TransitionProps, { style: {
                    transformOrigin: placementStyles.transformOrigin,
                }, timeout: open ? 180 : 0 }),
                React__default.createElement("div", null,
                    React__default.createElement(ClickAwayListener, { onClickAway: handleClose },
                        React__default.createElement("div", null,
                            React__default.createElement(MenuContent, { id: id, options: options, setExpandedOption: setExpandedOption, expandedOption: expandedOption, onClick: onClick, setOpen: setOpen }))))));
        }))));
};
var ZigMenu$1 = React__default.forwardRef(ZigMenu);

export { ZigMenu$1 as default };
